import { FormGroup } from '@angular/forms';

export function GreaterThanNumberAnnualPlanValidator(controlName: string, matchingControlName: string, orEqual = false) {
    return (formGroup: FormGroup) => {
        const control = formGroup.controls[controlName];
        const matchingControl = formGroup.controls[matchingControlName];

        const controlNumber = control.value ? control.value.number : null;
        const matchingControlNumber = matchingControl.value ? matchingControl.value.number : null;

        if (null === controlNumber || null === matchingControlNumber) {
            if (control.errors) {
                delete control.errors['greaterThanNumber'];
                if (Object.keys(control.errors).length === 0) {
                    control.setErrors(null);
                }
            }

            return;
        }

        // greater than or equal
        if (orEqual && controlNumber < matchingControlNumber) {
            control.setErrors({ greaterThanNumber: true });

            return;
        }

        // greater than
        if (!orEqual && controlNumber <= matchingControlNumber) {
            control.setErrors({ greaterThanNumber: true });

            return;
        }

        // remove existing errors
        if (control.errors) {
            delete control.errors['greaterThanNumber'];
            if (Object.keys(control.errors).length === 0) {
                control.setErrors(null);
            }
        }
    };
}
